import { Route, Routes, HashRouter as Router } from 'react-router-dom'

import CampaignPublic from '@sections/Public/packs/Campaign'

import Client from '.'
import Accounting from './packs/Accounting'
import AgencyAdmin from './packs/AgencyAdmin'
import AgencyMarketing from './packs/AgencyMarketing'
import ArtworkBuilder from './packs/ArtworkBuilder'
import Campaign from './packs/Campaign'
import Dashboard from './packs/Dashboard'
import Overviews from './packs/Overviews'
import PublicationManager from './packs/PublicationManager'
import ActivityLogs from './packs/ActivityLogs'

const ClientRoutes = () => (
  <Router>
    <Client>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/agencies/:agencyId/manage/*" element={<AgencyAdmin />} />
        <Route path="/agencies/:agencyId/manage/accounting/*" element={<Accounting />} />
        <Route path="/agency/marketing/*" element={<AgencyMarketing />} />
        <Route path="/artworks/*" element={<ArtworkBuilder />} />
        <Route path="/campaigns/:campaignId/edit/*" element={<Campaign />} />
        <Route path="/publications/*" element={<PublicationManager />} />
        <Route path="/agency/dashboard/agencies/:agencyId/overview/*" element={<Overviews />} />
        <Route path="/public/campaigns/:campaignId/*" element={<CampaignPublic />} />
        <Route path="/activity-logs" element={<ActivityLogs />} />
      </Routes>
    </Client>
  </Router>
)

export default ClientRoutes
